module.exports = __webpack_public_path__ + "images/logos/selfstorage-social-logo.png";